import { AuctionStatus, AuctionStatusType, ChannelType } from "@shared/clickar-constants";
import { VehicleDTO } from "./vehicle.model";
export class LotDTO {
	idVehicles?: number[];
	idLot: number;
	flgMultiItem?: boolean;
	acceptedOffers?: number;
	idDealerBestOffer?: number;
	bestOffer?: number;
	dateEnd: Date;
	dateLastOffer?: Date;
	startPrice?: number;
	currentPrice?: number;
	/** Manually filled-in, used for sorting: equals currentPrice if it's !== 0, otherwise startPrice  */
	actualPrice?: number;
	basePrice?: number;
	userMaxOffer?: number;
	notHigherReserve?: boolean;
	blink = false;
	status = AuctionStatus.RUNNING;
	active: boolean | null;
	first = true;
	flgClickbuy = false;
	clickbuyPrice?: number;
	calculatedStatus: AuctionStatusType | "EXTRA";
}

export class LotFullDTO {
	lotDTO: LotDTO;
	vehiclesDTO: VehicleDTO[];
	observed?: boolean;
	offer: number;
	reservePrice: boolean;

	awardEmail: string;
	recipients: string;
	ccRecipients: string;
	subject: string;
}

export class LotVehicle {
	lotDTO: LotDTO;
	vehicle?: VehicleDTO;
	offer: number;
	reservePrice: boolean;
}

export interface LotReportDTO {
	basePrice?: number;
	bestOffer?: number;
	maxRelaunch?: number;
	delta?: number;
	type?: number;
	typeStock?: boolean;
	typeSup?: boolean;
	idLot?: number;
	numOffers?: number;
	status?: string;
	flgMultiItem?: boolean;
	flgSup?: boolean;
	vehicles?: VehicleDTO[];
	bestBidder?: string;
}

export interface LotDetailDTO {
	auctionStatus?: string;
	awardedNumber?: number;
	awardedPrice?: number;
	basePrice?: number;
	dealerLogo?: number;
	endDate?: Date;
	idAuction?: number;
	idDealer?: number;
	idLot?: number;
	licensePlate?: string[];
	idVehicles?: number[];
	provenanceBusinessName?: string[];
	lotStatus?: string;
	numberAuction?: number;
	offers?: OfferDetailDTO[];
	startDate?: Date;
	flgClickbuy: boolean;
	clickbuyPrice?: number;
	clickbuyIdOffer?: number;
}

export interface OfferDetailDTO {
	idAuctionOffer?: number;
	businessName?: string;
	city?: string;
	dateOffer?: Date;
	idDealer?: number;
	idOffer?: number;
	priceOffer?: number;
	maxOfferValue?: number;
	telephone?: string;
	region?: string;
	selected?: boolean;
	outcome?: string;
	autoRaising?: boolean;
	flgAwardedOffer?: boolean;
	flgWinner?: boolean;
}

export interface Purchase {
	idPurchase?: number;
	idAuction?: number;
	/** NOTE: ISO 8601 string */
	datePurchase?: string;
	channel?: ChannelType;
	idUser?: number;
	idUserDealer?: number;
	idFeedback?: number;
	rating?: number;
	idLot?: number;
	idAuctioneer?: number;
	licensePlate?: string;
	frame?: string;
	idVehicle?: number;
	idTemplate?: number;
	smallLogo?: number;
	businessName?: number;
	auctionName?: string;
	awardEmail?: string;
	recipients?: string;
	ccRecipients?: string;
	subject?: string;
	price?: number;
	auctioneerRating?: number;
	numFeedback?: number;
	templateName: string;
	brand?: string;
	model?: string;
	version?: string;
	flgOnlinePayment?: boolean;
	flgPaid?: boolean;
}
/** Risposta paginata di GET /api/v2/secure/purchases */
export interface PurchasePageDTO {
	/** Acquisti trovati in totale, prima di applicare offset/limit */
	total: number;
	data: Purchase[];
}
